export enum DeviceAntennaType {
  Internal = 'INTERNAL',
  External1 = 'EXTERNAL_1',
  External2 = 'EXTERNAL_2',
  External3 = 'EXTERNAL_3',
}
